import OAA from 'actions/dod/dodOfficeAddressActions';

export function dodOfficeAddressUpdateField(f) {
    return { type: OAA.UPDATE_DOD_OFFICE_ADDRESS_FIELD, payload: f };
}

export function dodOfficeAddressUpdateTitle(t) {
    return { type: OAA.UPDATE_DOD_OFFICE_ADDRESS_TITLE, payload: t };
}

export function dodOfficeAddressUpdateSelectOptions(f) {
    return { type: OAA.UPDATE_DOD_OFFICE_ADDRESS_OPTIONS, payload: f };
}
